<template>
  <article class="patient-info-wrap" :class="{'search-patient-wrap': isPatientSearch}">
    <img src="/static/Rolling.svg" alt="loading" v-if="isLoading">
    <div class="content" v-else>
      <div class="info">
        <span>수진자
          <br> 정보</span>
        <ul class="patient-info-header">
          <li class="chartnum-header">
            고객번호
          </li>
          <li>
            이름
          </li>
          <li>
            성별
          </li>
          <li>
            연령
          </li>
        </ul>
        <ul class="patient-info" v-if="waitPatientInfo">
          <li class="chart-num">
            {{waitPatientInfo.chart_num}}
          </li>
          <li>
            {{waitPatientInfo.pat_nm}}
          </li>
          <li>
            {{waitPatientInfo.pat_age}}
          </li>
          <li>
            {{waitPatientInfo.pat_gen}}
          </li>
        </ul>
      </div>
      <div class="patient-info-state" v-if="patientState.length">
        <ul>
          <li v-for="(info, index) in patientState" :key="index">
            <span :class="{'treat-name': true,'ten-letter': info.room_nm.length > 10, 'seven-letter': info.room_nm.length > 7, 'two-letter': info.room_nm.length < 3}">
              {{info.room_nm}}
            </span>

            <span :class="{'treat-state': true, 'no-start': info.state === '미진행', wait: info.state === '대기중', treat: info.state === '진료중', complete: info.state === '완료'}" @click="changeState(waitPatientInfo.pat_nm, info.state,info.room_id, waitPatientInfo.chart_num, info.room_nm)">
              {{info.state}}
            </span>
          </li>
        </ul>
        <div class="tip-text">수진자를 다른 검사실로 이동하시려면 미진행을 클릭해주세요.</div>
      </div>
      <div v-else-if='errorMsg' class="error-msg">
        {{errorMsg}}
      </div>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    waitPatientInfo: Object,
    patientState: Array,
    isPatientSearch: Boolean,
    isLoading: Boolean,
    errorMsg: String
  },
  methods: {
    changeState (name, state, roomNum, patNum, treatInfo) {
      if (this.isPatientSearch) {
        this.$emit('patientChangeState', name, state, roomNum, patNum, treatInfo)
      } else {
        this.$emit('onChangeState', name, state, roomNum, patNum, treatInfo)
      }
    }
    // showConfirm (name, state, roomNum, patNum, treatInfo) {
    //   let question
    //   let code
    //   if (state === '미진행') {
    //     code = 0
    //     question = confirm(`${name} 님을 ${treatInfo}으로 이동 하시겠습니까?`)
    //   } else if (state === '대기중') {
    //     code = 1
    //     question = confirm(`${name} 님을 ${treatInfo}으로 접수 하시겠습니까?`)
    //   } else if (state === '검사중') {
    //     code = 2
    //     question = confirm(`${name} 님을 ${treatInfo}으로 호출 하시겠습니까?`)
    //   } else {
    //     alert('검사가 완료된 환자 입니다.')
    //   }
    //   if (question && !code) {
    //     debugger
    //     this.$http.get('/manage_api/jubsu.php', {
    //       params: {
    //         room_id: roomNum,
    //         pat_id: patNum
    //       }
    //     })
    //       .then(result => {
    //         debugger
    //       })
    //       .catch(err => {
    //         console.log(err)
    //         debugger
    //       })
    //   } else if (question) {
    //     this.$http.get('/manage_api/stat_update.php', {
    //       params: {
    //         room_id: roomNum,
    //         pat_id: patNum,
    //         stat: code + 1
    //       }
    //     })
    //       .then(result => {
    //         debugger
    //       })
    //       .catch(err => {
    //         console.log(err)
    //         debugger
    //       })
    //   }
    // }
  }
}
</script>

<style scoped lang='scss'>
.patient-info-wrap {
  margin-top: 3vh;
  margin-left: 1vw;
  width: 52vw;
  height: 36vh;
  // float: left;
  border: 1px solid #aaaaaa;
  background-color: white;
  position: relative;
  overflow: hidden;
  left: 1vw;
  top: 2.6vh;
  img[alt='loading'] {
    display: block;
    position: absolute;
    width: 80px;
    height: 80px;
    left: 50%;
    margin-left: -40px;
    top: 50%;
    margin-top: -40px;
  }
  .content {
    width: 52vw;
    height: 37vh;
    overflow: hidden;
  }
  .patient-info {
    width: 39.5vw;
    float: left;
    position: relative;
    bottom: 8px;
    li {
      border-right: none;
      display: inline-block;
      width: 9vw;
      text-align: center;
      color: white;
      height: 4vh;
      line-height: 4vh;
      margin-top: 1vh;
      font-size: 22px;
      white-space: nowrap;
      overflow: auto;
      &:first-child {
        width: 11vw;
      }
      &:nth-child(2) {
        width: 10vw;
      }
      &:nth-child(3),
      &:nth-child(4) {
        width: 7vw;
      }
    }
    .chart-num {
      font-size: 20px;
      text-align: center;
      position: relative;
    }
  }
  .info {
    width: 100%;
    height: 10vh;
    background-color: #036eb8;
    > span {
      display: block;
      width: 7vw;
      height: 10vh;
      float: left;
      text-align: center;
      padding-top: 2.2vh;
      font-size: 22px;
      background-color: #b5b5b6;
      margin-right: 5.25vw;
      font-weight: bold;
      color: rgb(94, 92, 92);
    }
  }
}

.patient-info-header {
  // position: absolute;
  width: 39.5vw;
  float: left;
  bottom: 3px;
  li {
    // float: left;
    display: inline-block;
    width: 9vw;
    text-align: center;
    color: white;
    height: 4vh;
    line-height: 4vh;
    margin-top: 1vh;
    font-size: 22px;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      top: 18%;
      right: -3px;
      height: 60%;
      width: 100%;
      border-right: 1.5px solid #e6e6e6;
    }
    &:first-child {
      text-align: center;
      width: 11vw;
    }
    &:nth-child(2) {
      width: 10vw;
    }
    &:nth-child(3),
    &:nth-child(4) {
      width: 7vw;
    }
    &:last-child::before {
      border-right: none;
    }
  }
}

.patient-info-state {
  position: relative;
  height: 22vh;
  bottom: 0.5vh;
  //  fixed thead 테스트코드
  // height: 10px;
  width: 100%;
  overflow: auto;
  ul {
    width: 100%;
    li {
      display: inline-block;
      font-size: 22px;
      width: 17vw;
      margin: 0px;
      height: 5.8vh;
      line-height: 5.8vh;
      padding: 0px;
      border-right: 1px solid #ccc;
      color: black;
      &:nth-child(3n) {
        border-right: none;
      }
    }
  }
  .treat-name {
    position: relative;
    left: 1.6vw;
  }
  .treat-state {
    position: relative;
    right: 1.6vw;
    float: right;
  }
  .wait {
    right: 2.1vw;
  }
  .no-start {
    color: #036eb8;
  }
  .complete {
    color: #e83828;
    right: 2.1vw;
  }
  .treat {
    color: #27ae60;
  }
  .tip-text {
    width: 52vw;
    position: fixed;
    height: 4vh;
    line-height: 4vh;
    bottom: 2vh;
    right: 2vw;
    text-align: center;
    color: white;
    background-color: #898989;
  }
  .seven-letter {
    font-size: 15px;
    bottom: 3px;
  }
  .ten-letter {
    font-size: 13px;
  }
  .two-letter {
    left: 3.2vw;
  }
}
@media screen and (min-width: 1500px) {
  .patient-info-state ul li {
    width: 16vw;
  }
  .patient-info-wrap .patient-info li:first-child {
    text-align: center;
    padding-left: 0.7vw;
  }
  //PatientSearch overRiding
  .search-patient-wrap .patient-info-header {
    margin-top: 1.5vh;
  }
}
@media screen and (min-width: 2000px) {
  //PatientSearch overRiding
  .search-patient-wrap .patient-info-header {
    margin-top: 0px;
  }
}
@media screen and (max-width: 1230px) {
  .patient-info-header li {
    font-size: 18px;
  }
  .patient-info-state {
    .seven-letter {
      font-size: 12px;
    }
    .ten-letter {
      font-size: 10px;
    }
    ul li {
      font-size: 17px;
    }
  }
  .patient-info-wrap .patient-info {
    li {
      margin-top: 1.5vh;
      font-size: 20px;
    }
    .chart-num {
      font-size: 15px;
      right: 0px;
    }
  }
  //PatientSearch overRiding
  .search-patient-wrap .patient-info-state {
    .seven-letter {
      font-size: 19px !important;
    }
    .ten-letter {
      font-size: 17px !important;
    }
    ul li {
      font-size: 24px !important;
    }
  }
}

@media screen and (max-width: 1000px) {
  .patient-info-wrap .info > span {
    font-size: 18px;
    padding-top: 1.8vh;
  }
  .patient-info-state {
    .seven-letter {
      font-size: 11px;
    }
    .ten-letter {
      font-size: 9px;
    }
  }
  //PatientSearch overRiding
  .search-patient-wrap {
    .patient-info-header {
      padding-top: 23px !important;
    }
    .patient-info-header li,
    .patient-info li {
      font-size: 24px !important;
    }
    .patient-info-state {
      .seven-letter {
        font-size: 17px !important;
      }
      .ten-letter {
        font-size: 15px !important;
      }
    }
  }
}
//PatientSearch overRiding
.search-patient-wrap {
  width: 82vw;
  height: 80vh;
  margin-top: 0px;
  top: 10vh;
  left: 3vw;
  .content {
    width: auto;
    height: 80vh;
    overflow: auto;
  }
  .info {
    font-size: 28px;
    height: 110px;
    > span {
      width: 105px;
      height: 110px;
      font-size: 28px;
      padding-top: 24px;
      margin-right: 9vw;
    }
    .patient-info {
      li {
        &:first-child {
          width: 15.7vw;
        }
        width: 12.5vw;
        font-size: 28px;
      }
    }
  }

  .patient-info-header {
    padding-top: 15px;
    li {
      font-size: 28px;
    }
  }

  .patient-info {
    padding-top: 0.5vh;
  }
  .patient-info-header,
  .patient-info {
    width: 56vw;
    li {
      &:first-child {
        width: 15.7vw;
      }
      width: 12.5vw;
    }
  }
  .chart-num {
    font-size: 25px;
  }
  .tip-text {
    width: 82vw;
    height: 4.5vh;
    line-height: 4.5vh;
    right: 3.5vw;
    bottom: 10vh;
  }

  .patient-info-state {
    position: relative;
    height: 62vh;
    bottom: 0px;
    ul {
      width: 80vw;
      margin: 2vh auto 0px auto;
      li {
        padding-bottom: 1.5vh;
        width: 26.2vw;
        font-size: 30px;
        display: inline-block;
        height: 5.8vh;
        line-height: 5.8vh;
        .treat-name {
          left: 2.8vw;
        }
        .treat-state {
          right: 2.8vw;
        }
      }
    }
    .seven-letter {
      font-size: 22px;
      bottom: 3px;
    }
    .ten-letter {
      font-size: 20px;
    }
  }
}

.error-msg {
  text-align: center;
  font-size: 22px;
  position: relative;
  top: 38%;
}

@media screen and (min-width: 1300px) {
  .search-patient-wrap .patient-info-header {
    padding-top: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/PatientInfo.vue